import React from "react";
import { Label, Select } from "@src/common/components";
import {
  CustomRecurrenceScheduleType,
  ExtendedRecurrenceScheduleType,
} from "../utils/CreateOrderContextProvider";
import { RecurrenceScheduleType } from "@api/graphql/generated/generated-types";
import { useAuth } from "@src/common/hooks/useAuth";

type Props = {
  recurrenceSchedule: ExtendedRecurrenceScheduleType;
  handleChange: (params: any) => void;
  isRecurringOnly?: boolean;
};

function SelectOrderRecurrence({
  recurrenceSchedule,
  handleChange,
  isRecurringOnly = false,
}: Props) {
  const { hasPermission } = useAuth();
  const canCreateRecurring = hasPermission("orders.createRecurring");

  // Built inside the component: CreateOrderContextProvider ↔ GeneralForm ↔
  // this file is a circular import, so CustomRecurrenceScheduleType is undefined
  // at module-evaluation time.
  const allOptions = [
    {
      label: "Does Not Repeat",
      id: CustomRecurrenceScheduleType.DoesNotRepeat,
    },
    { label: "Daily", id: RecurrenceScheduleType.Daily },
    {
      label: "Custom Days Of The Week",
      id: RecurrenceScheduleType.CustomDaysOfTheWeek,
    },
    {
      label: "Custom Days Of The Month",
      id: RecurrenceScheduleType.CustomDaysOfTheMonth,
    },
    { label: "Biweekly", id: RecurrenceScheduleType.Biweekly },
    { label: "Every N Weeks", id: RecurrenceScheduleType.EveryNWeeks },
    { label: "Monthly On First", id: RecurrenceScheduleType.MonthlyOnFirst },
    { label: "Monthly On Second", id: RecurrenceScheduleType.MonthlyOnSecond },
    { label: "Monthly On Third", id: RecurrenceScheduleType.MonthlyOnThird },
    { label: "Monthly On Fourth", id: RecurrenceScheduleType.MonthlyOnFourth },
    { label: "Monthly On Last", id: RecurrenceScheduleType.MonthlyOnLast },
    { label: "Monthly On Fifth Week (if applicable)", id: RecurrenceScheduleType.MonthlyOnFifthWeek },
    { label: "Manual", id: RecurrenceScheduleType.ManualOnly },
    {
      label: "Follow Route Schedule",
      id: RecurrenceScheduleType.FollowRouteSchedule,
    },
  ];

  let recurrenceScheduleOptions = allOptions;
  if (isRecurringOnly) {
    recurrenceScheduleOptions = allOptions.filter(
      (option) => option.id !== CustomRecurrenceScheduleType.DoesNotRepeat
    );
  } else if (!canCreateRecurring) {
    recurrenceScheduleOptions = allOptions.filter(
      (option) => option.id === CustomRecurrenceScheduleType.DoesNotRepeat
    );
  }
  return (
    <>
      <Label
        htmlFor={"Service Type"}
        className="block text-xs font-medium text-gray-700 dark:text-gray-300 truncate"
      >
        Order Recurrence
      </Label>
      <Select
        options={recurrenceScheduleOptions}
        value={recurrenceScheduleOptions.filter(
          (option) => option.id === recurrenceSchedule
        )}
        size="mini"
        clearable={false}
        onChange={handleChange}
        searchable={false}
        disabled={!isRecurringOnly && !canCreateRecurring}
      />
    </>
  );
}

export default SelectOrderRecurrence;
